function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// DO NOT EDIT THIS FILE BECAUSE IT IS GENERATED AUTOMATICALLY
import React from "react";
import PropTypes from "prop-types";

const TextUnderline = _ref => {
  let {
    size = "1em",
    color = "currentColor",
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    style: {
      width: size,
      height: size
    },
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: title ? 'img' : 'presentation'
  }), title ? /*#__PURE__*/React.createElement("title", null, title) : null, " ", /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M17.654 3.5v8.238c0 1.055-.226 1.978-.678 2.769-.453.79-1.107 1.4-1.963 1.826-.856.426-1.88.64-3.072.64-1.77 0-3.147-.47-4.13-1.407-.984-.937-1.475-2.226-1.475-3.867V3.5H8.68v8.033c0 1.179.273 2.048.82 2.608.547.56 1.387.84 2.52.84 2.2 0 3.3-1.156 3.3-3.467V3.5h2.334zM5 19.75c0-.414.332-.75.753-.75h12.494a.75.75 0 1 1 0 1.5H5.753A.75.75 0 0 1 5 19.75z"
  }, " "));
};

TextUnderline.propTypes = {
  /** The width/height of the icon as any CSS size unit */
  size: PropTypes.string,

  /** The fill color of the icon as any CSS color value */
  color: PropTypes.string,

  /** The title to add as a child of the root svg element */
  title: PropTypes.string
};
export default TextUnderline;